import { useEffect, useRef } from 'react'

import { registerEscapeLayer } from './stack'

export const useEscapeLayer = (open: boolean, onEscape: () => void) => {
  const onEscapeRef = useRef(onEscape)
  onEscapeRef.current = onEscape

  useEffect(() => {
    if (!open) {
      return
    }

    return registerEscapeLayer(() => onEscapeRef.current())
  }, [open])
}
